import { render, staticRenderFns } from "./PageTitleBar.vue?vue&type=template&id=792b073d"
import script from "./PageTitleBar.vue?vue&type=script&lang=js"
export * from "./PageTitleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports